<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Nova Anotação' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <div class="gradient-extendido"></div>

    <div class="ion-margin border-bottom">
      <ion-label position="stacked" class="anotacao">
        {{'Descrição da Anotação' | translate}}
      <ion-text color="danger">*</ion-text></ion-label>

      <ion-textarea
        rows="10"
        type="text"
        formControlName="anotacao"
        placeholder="{{'Digite sua anotação aqui...' | translate}}"
      ></ion-textarea>
    </div>
    <div class="validation-errors">
      <ng-container *ngFor="let validation of validation_messages.anotacao">
        <div
          class="error-message ion-margin-start"
          *ngIf="validations_form.get('anotacao')?.hasError(validation.type) &&
          (validations_form.get('anotacao')?.dirty || validations_form.get('anotacao')?.touched)"
        >
          {{ validation.message }}
        </div>
      </ng-container>
    </div>

    <div class="down">
      <ion-button class="btn-success" type="submit" [disabled]="!validations_form.valid">
        {{'Salvar anotação' | translate}}
      </ion-button>
    </div>
  </form>
</ion-content>
